module.exports = __webpack_public_path__ + "assets/img/29_219.13310f29.jpg";